/**
 * Config Adapter
 * Wraps configuration utilities to provide adapter interface
 */

import type { ConfigAdapter as IConfigAdapter } from '../types/adapters.types';
import { AUTH_API_CONFIG, AUTH_API_ENDPOINTS } from '../../../config/api.config';
import {
  buildApiScope,
  isExternalId,
} from '../../../config/msal.config';
import {
  shouldUseMsalRedirect,
  shouldEnableMsalPopupFallback,
} from '../../../utils/featureFlags.utils';

/**
 * Create Config adapter
 * 
 * @returns ConfigAdapter implementation
 */
export function createConfigAdapter(): IConfigAdapter {
  return {
    getApiBaseUrl: () => {
      return AUTH_API_CONFIG.baseUrl || '';
    },
    getLogoutEndpoint: () => {
      return AUTH_API_ENDPOINTS.logout || null;
    },
    getPostLogoutRedirectUri: () => {
      return import.meta.env.VITE_AZURE_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/login`;
    },
    shouldUseRedirect: () => {
      return shouldUseMsalRedirect();
    },
    shouldEnablePopupFallback: () => {
      return shouldEnableMsalPopupFallback();
    },
    buildApiScope: () => {
      return buildApiScope();
    },
    isExternalId: () => {
      return isExternalId();
    },
  };
}
